// Re-export posthog instance for manual event tracking in non-component code.
// The provider in main.tsx handles initialization.
// Use `usePostHog()` hook from @posthog/react inside components when possible.
import posthog from 'posthog-js';

export { posthog };

/**
 * Every fan-page event carries is_test so Insights and reports can drop staff
 * QA from seats flagged seats.is_test (the TEST seat produced 13 of 20
 * "fan" views at HJK vs VPS, 8 Oct 2026).
 */
export function fanEventProps<T extends object>(props: T, isDemoSeat: boolean): T & { is_test: boolean } {
  return { ...props, is_test: isDemoSeat };
}
